import { TagsInput } from '@mantine/core';
import classes from './TagsInput.module.css';

export const TagsInputConfig = TagsInput.extend({
  classNames: { pill: classes.pill },
});
